export const checkRequiredFieldsForCountry = (
	countryShort,
	city,
	postalCode,
	street,
	building,
) => {
	let allRequiredFieldsFilled = true;

	if (countryShort === 'bg') {
		allRequiredFieldsFilled = city && postalCode && street;
	} else {
		allRequiredFieldsFilled = city && postalCode && street && building;
	}
	return allRequiredFieldsFilled;
};
